module.exports = __webpack_public_path__ + "Assets/Stoerer_NW_PP_Sachpraemien.svg";